import angular from 'angular';
import expenseWizardComponent from './expense-wizard.component';

let expenseWizardModule = angular.module('expenseWizard', [])
  .component('expenseWizard', expenseWizardComponent);

export default expenseWizardModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/expense-wizard/expense-wizard.js